function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-nocheck

import { $uniDebug } from "../uni-debug.module";
var JsonDevDirective = /*#__PURE__*/function () {
  function JsonDevDirective($log, $timeout, UniConfig) {
    _classCallCheck(this, JsonDevDirective);
    _defineProperty(this, "priority", -999);
    this.$log = $log;
    this.$timeout = $timeout;
    this.UniConfig = UniConfig;
    this.restrict = "A";
    this.scope = {
      jsonDev: "<",
      forzar: "<"
    };
  }
  return _createClass(JsonDevDirective, [{
    key: "compile",
    value: function compile(element, attrs) {
      this.$log.debug("******** Compile jsonDev", element.html());
      if (!attrs.forzar && !this.UniConfig.debug) {
        attrs.jsonDev = "";
        element.removeAttr("json-dev");
        element.empty();
      }
      return this.link;
    }
  }, {
    key: "link",
    value: function link(scope, element, attrs, ctrls) {
      // $log.debug("Instanciando JsonDevDirective", scope);

      if (attrs.forzar || this.UniConfig.debug) {
        // this.$log.debug("Activando titleDev", element);
        this.$timeout(function () {
          element.addClass("if__dev");
          element.attr("title", attrs.jsonDev);
          element.removeAttr("json-dev");
        }, 2000);
      }
    }
  }, {
    key: "template",
    value: function template() {
      return /* html */"\n<sidebar-tooltip-click>\n<div class=\"json-formatter-container ng-hide pull-right\">\n<json-formatter json=\"jsonDev\" open=\"1\"></json-formatter>\n</div>\n<span title-dev=\"{{::jsonDev | json}}\">???</span>\n</sidebar-tooltip-click>\n";
    }
  }]);
}();
$uniDebug.directive("jsonDev", ["$log", "$timeout", "UniConfig", function ($log, $timeout, UniConfig) {
  return new JsonDevDirective($log, $timeout, UniConfig);
}]);
import "./json-dev.directive.scss";